import React, { useEffect, useState } from 'react'
import { FormControl, FormHelperText, Grid, Input, makeStyles, TextField, withStyles } from '@material-ui/core';
import './index.scss'
import { useMedia } from '@commons/media';
import { useTranslation } from 'react-i18next';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Link } from 'react-router-dom';
import parser from 'react-html-parser'
import RootStore from '@stores';
import { base64Decode, errorCaptured } from '@commons/util';
import ajax from '@commons/api/ajax';
import CONFIG from '@commons/api/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { LineStyle } from '@material-ui/icons';
import { MGMAccounts } from '@interfaces/portal';


interface AccountFormProps {
    select: number,
    isLogin: boolean,
    mgmAccounts: MGMAccounts,
    confirmLogin: (arg0: boolean) => void
}

// 自定义 Input 样式
const useStyles = makeStyles({
    inputRoot: {
        flex: 1,
        border: '2px solid #005288',
        padding: '8px 30px',
        fontSize: '16px',
        backgroundColor: '#fff',
        borderRadius: '6px',
        '&:hover': {
            borderColor: '#005288', // 去除 hover 时的边框颜色
        },
        '&:focus': {
            borderColor: '#005288', // 去除 focus 时的边框颜色
        },
        '&$focused': {
            borderColor: '#005288', // 聚焦时的边框颜色（你可以保持聚焦边框的样式，也可以完全去除）
        },
    },
    focused: {
        border: '2px solid #e59700',
        borderRadius: '6px',
        borderColor: "#000"
    },
    helperText: {
      fontSize: '24px',
      color: '#f50057', // 错误提示文字颜色
    },
    content: {
        '& a': {
            textDecoration: 'underline',
        }
    }
});

const AccountForm:React.FC<AccountFormProps> = (props)=> {
    const {
        mgmAccounts
    } = props;
    const { langTag } = RootStore.BasicInfoStore;
    const { mediaClass, mbMatches} = useMedia()
    const {select, confirmLogin}= props;
    const classes = useStyles()
    const [telNum, setTelNum] = useState('');
    const {i18n} = useTranslation();
    const [telNumError, setTelNumError] = useState(false);
    const [accountForm, setAccountForm] = useState({
        account: '',
        telNum: '',
        isLogging: false
    })
    const [accountFormError, setAccountFormError] = useState({
        account: false,
        telNum: false,
    });
    const {
        getMGMCode
    } = RootStore.BasicInfoStore;

    const refferalRedirectUrl = {
        "en-US": 'https://www.hkbn.net/personal/Redirect/Landing/Home/en/{code}?utm_source=aio&utm_medium=referral_redirection&utm_campaign=mgm',
        "zh-HK": 'https://www.hkbn.net/personal/Redirect/Landing/Home/tc/{code}?utm_source=aio&utm_medium=referral_redirection&utm_campaign=mgm'
    }

    const handleChangeTelNum = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTelNum(event?.target?.value)
    }

    const handleChangeAccount = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAccountForm({
            ...accountForm,
            account: event?.target?.value
        })
        setAccountFormError({account: false, telNum: false})
    }

    const handleChangeAccountTelNum = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAccountForm({
            ...accountForm,
            telNum: event?.target?.value
        })
        setAccountFormError({account: false, telNum: false})
    }

    const handleSumbmitReferralCode = async () => {
        if (!telNum) {return setTelNumError(true)}
        let [err, res] = await getReferralCodeLogin(telNum)
        
        if (err || res.code !== 0) {
            setTelNumError(true)
            return
        }
        setTelNumError(false)
        window.open(refferalRedirectUrl[i18n.language as keyof typeof refferalRedirectUrl].replace('{code}', telNum), '_blank')
    }

    const handleSumbmitAccount = async () => {
        if (!accountForm.account || !accountForm.telNum) {
            const newErrorState = {
                account: !accountForm.account,
                telNum: !accountForm.telNum,
                isLogging: false
            }
            setAccountFormError(newErrorState)
            return
        }

        setAccountForm({
            ...accountForm,
            isLogging: true
        })
        let err = await getLogin(accountForm)
        setAccountForm({
            ...accountForm,
            isLogging: false
        })
        if (err) {
            setAccountFormError({account: true, telNum: true})
            return
        }
        console.log(accountForm, 'ok');
        setAccountFormError({account: false, telNum: false})
    }



    const getLogin = async(params: {account: string, telNum: string}) => {
        const transParams = {
            customerId: params.account,
            password: params.telNum
        }
        const [err, success] = await errorCaptured(
            ajax.post({
                url: CONFIG.API.GET_ACCOUNT_LOGIN,
                config: {
                    data: transParams
                }
            })
        )
        if (success) {
            let result = await getMGMCode()
            result && confirmLogin(true)
            return
        }
        return err
    }

    const getReferralCodeLogin = async(code: string) => {
        const [err, res] = await errorCaptured(
            ajax.get({
                url: `${CONFIG.API.GET_REFERRAL_LOGIN}?code=${code}`,
            })
        )
        return [err, res];
    }

    useEffect(() => {
        console.log(i18n.language);
        
    }, [])
    const isWechatMiniProgram = () => {
        const ua = navigator.userAgent.toLowerCase();
        return ua.includes('miniprogram') && ua.includes('micromessenger');
    };
    return (
        <Grid container className={`main-account-maxwidth ${mediaClass('account-form')}`}>
            {/* <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackbarFlag}
                message="invalid account or password"
                key={'top-center'}
            /> */}
            {
                // refferral left selection
                select === 0 ? 
                (
                    <Grid container direction={mbMatches? 'column' : 'row'} justifyContent='center' alignItems={'center'} wrap="nowrap">
                        <Grid container item justifyContent='center' >
                            <Grid container item direction='column' className={`${mediaClass('account-form-account-login')}`}>
                                {
                                    isWechatMiniProgram() ? <Grid container justifyContent='center'>
                                        <span className='mini-share-desc'>請輸入電話號碼及香港寬頻賬戶</span>
                                        <span className='mini-share-desc'>查詢您的推薦人編號</span>
                                    </Grid> : mgmAccounts.referralTagLine && <div className={classes.content}>
                                    {parser(base64Decode(mgmAccounts.referralTagLine))}
                                 </div>
                                }
                                <Grid container item justifyContent='center' alignItems='flex-start' className={`${mediaClass('accout-form-login-form-input')}`}>
                                    {/* login form */}
                                    <Grid container item className={`${mediaClass('account-form-input')}`}>
                                        <FormControl error={accountFormError.account} fullWidth>
                                            <Grid container direction='row' className='account-form-margin'>
                                                <Input
                                                    classes={{
                                                        root: classes.inputRoot,
                                                        focused: classes.focused
                                                    }}
                                                    disableUnderline={true}
                                                    placeholder={i18n.t('portal:accountLabel')}
                                                    value={accountForm.account}
                                                    onChange={handleChangeAccount}
                                                />
                                            </Grid>
                                            <FormHelperText className='form-error-text'>
                                                {accountFormError.account ? `${i18n.t('portal:accountLabel')} ${i18n.language === 'zh-HK' ? "錯誤" : "Error"}` : ''}
                                            </FormHelperText>
                                        </FormControl>
                                        <FormControl error={accountFormError.telNum} fullWidth>
                                            <Grid container direction='row' className='account-form-margin'>
                                                <Input
                                                    classes={{
                                                        root: classes.inputRoot,
                                                        focused: classes.focused
                                                    }}
                                                    type='password'
                                                    disableUnderline={true}
                                                    placeholder={i18n.t('portal:contactNoLabel')}
                                                    value={accountForm.telNum}
                                                    onChange={handleChangeAccountTelNum}
                                                />
                                            </Grid>
                                            <FormHelperText className='form-error-text'>
                                                {accountFormError.telNum ? `${i18n.t('portal:contactNoLabel')} ${i18n.language === 'zh-HK' ? "錯誤" : "Error"}` : ''}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item style={{marginTop: '40px', position: 'absolute', right: '0'}}>
                                        <div className={`${mediaClass('account-form-input-button')}`} onClick={handleSumbmitAccount}>
                                            <img src={mgmAccounts.accountLoginIcon} alt="login icon" style={{width: '25px', height: '30px'}} />
                                        </div>
                                    </Grid>
                                    <Grid container justifyContent='flex-end' className={`${mediaClass('account-form-tnc')} ${i18n.language === 'zh-HK' ? '' : 'account-form-tnc-en'}`}>
                                        {langTag && <Link to={`/${langTag}/tnc`} className='tnc-button'>{i18n.t('portal:TNC')}</Link>} 
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ) : <></>
            }
            {
                // new customer right selection
                select === 1 ?
                <Grid container item xs={12} justifyContent='center' className='account-form-telnum-login'>
                    <Grid container item className={`${mediaClass('account-form-account-login')}`} direction='column' justifyContent='center' alignItems='center' wrap="nowrap" >
                        {mgmAccounts.newCustomerTagLine && <div className={classes.content}>
                            {parser(base64Decode(mgmAccounts.newCustomerTagLine))}
                        </div>}
                        <Grid item container className={`${mediaClass('accout-form-login-form-input')} account-form-margin `}>
                            <Grid container justifyContent='flex-end' wrap='nowrap' style={{marginRight: '10px'}} >
                                <Grid container className={`${mediaClass('account-form-input')}`}>
                                    <FormControl error={telNumError}  fullWidth>
                                        <Input
                                            classes={{
                                                root: classes.inputRoot,
                                                focused: classes.focused,
                                            }}
                                            disableUnderline={true}
                                            placeholder={mgmAccounts.referralCodeHolder}
                                            value={telNum}
                                            onChange={handleChangeTelNum}
                                        />
                                        <FormHelperText className='form-error-text'>
                                            {telNumError ? `${i18n.t('portal:ReferralCodeError')}` : ''}
                                        </FormHelperText>
                                    </FormControl>
                                </Grid>
                                <div className={`${mediaClass('account-form-input-button')}`} onClick={handleSumbmitReferralCode}>
                                    {/* <FontAwesomeIcon icon={faArrowRight} style={{fontSize: '1.5rem'}} /> */}
                                    <img src={mgmAccounts.accountLoginIcon} alt="login icon" style={{width: '25px', height: '30px'}} />
                                </div>
                                
                            </Grid>
                            <Grid container justifyContent='flex-end' className={`${mediaClass('account-form-tnc')} ${i18n.language === 'zh-HK' ? '' : 'account-form-tnc-en'}`}>
                                {langTag && <Link to={`/${langTag}/tnc`} className='tnc-button'>{i18n.t('portal:TNC')}</Link>} 
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid> : <></>
            }
        </Grid>
    )
}

export default AccountForm;